import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostShippingLabelsPrintParams } from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 운송장 출력 API
 */
const fetchPostShippingLabelsPrint = async (params: TypePostShippingLabelsPrintParams): Promise<void> => {
  const response = await axiosInstance.post(API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_PRINT, params, {
    responseType: 'blob',
  });

  downloadBlobDataFile(response);
};

/**
 * [운송장 관리] 운송장 출력 Mutation Hook
 */
export const usePostShippingLabelsPrintMutation = () => {
  return useDownloadMutation<void, TypeErrorResponseData['error'], TypePostShippingLabelsPrintParams>(
    fetchPostShippingLabelsPrint
  );
};
